import React, { useState, useEffect } from 'react';
import { Spin } from 'antd'; // Importa Spin de Ant Design
import axios from 'axios';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import './dashboard.css';
import moment from 'moment';
import BotonWhatsapp from '../../newInterface/botonWhatsapp/botonWhatsapp';

/**
 * Componente principal para mostrar el tablero de control con estadísticas y datos relevantes.
 * @component
 */
const Dashboard = () => {
  const [startDate, setStartDate] = useState(moment().subtract(1, 'year').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [idsucursal, setIdsucursal] = useState('');
  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [sucursalData, setSucursalData] = useState(null);

  const usuario_id = localStorage.getItem('usuario_id');

  const fetchData = async () => {
    if (!usuario_id) return;

    setLoading(true);
    try {
      const response = await axios.get(
        `https://api.99envios.app/api/panel-sucursales/${usuario_id}/${startDate}/${endDate}`
      );
      setSucursalData(response.data);
    } catch (error) {
      console.error('Error al obtener datos del tablero:', error);
      alert('Error al cargar los datos del tablero');
    } finally {
      setLoading(false);
    }
  };

  /**
   * Hook de efecto para obtener el ID de la sucursal del usuario actual.
   * Se ejecuta una vez al montar el componente.
   */
  useEffect(() => {
    const fetchSucursalId = async () => {
      try {
        const response = await axios.get(`https://99envios.app/api/online/sucursal-codigo-sucursal/${usuario_id}`);
        setIdsucursal(response.data);
      } catch (error) {
        console.error('Error al obtener el ID de la sucursal', error);
      }
    };

    if (usuario_id) {
      fetchSucursalId();
    }
  }, [usuario_id]);

  // Efecto para cargar datos iniciales
  useEffect(() => {
    fetchData();
  }, [usuario_id]); // Se ejecutará cuando el usuario_id esté disponible

  // Efecto para actualizar datos cuando cambien las fechas
  useEffect(() => {
    if (startDate && endDate && usuario_id) {
      fetchData();
    }
  }, [startDate, endDate]);

  const handleDateChange = (e, dateType) => {
    const newDate = e.target.value;
    
    if (dateType === 'start') {
      // Validar que la fecha inicio no sea mayor que la fecha fin
      if (newDate > endDate) {
        alert('La fecha de inicio no puede ser mayor que la fecha de fin');
        return;
      }
      setStartDate(newDate);
    } else {
      // Validar que la fecha fin no sea menor que la fecha inicio
      if (newDate < startDate) {
        alert('La fecha de fin no puede ser menor que la fecha de inicio');
        return;
      }
      setEndDate(newDate);
    }
  };

  // Función para calcular totales
  const calcularTotales = () => {
    if (!sucursalData?.estadisticas_pedidos) return {
      total: 0,
      entregados: 0,
      devueltos: 0,
      enProceso: 0
    };

    const stats = sucursalData.estadisticas_pedidos;
    return {
      total: stats.total || 0,
      entregados: stats.Entregado || 0,
      devueltos: stats.Devuelto || 0,
      enProceso: stats["En proceso"] || 0
    };
  };

  // Función para calcular porcentajes
  const calcularPorcentajes = (totales) => {
    if (totales.total === 0) return { entrega: "0.00%", devolucion: "0.00%" };
    return {
      entrega: ((totales.entregados / totales.total) * 100).toFixed(2) + "%",
      devolucion: ((totales.devueltos / totales.total) * 100).toFixed(2) + "%"
    };
  };

  const totales = calcularTotales();
  const porcentajes = calcularPorcentajes(totales);

  return (
    <>
      <Navbar title={"Tablero"} />
      <div className="dashboard-containerM">
        <div className="date-pickerM-containerM">
          <div className="date-pickerM-row">
            <div className="date-pickerM">
              <label>Fecha inicio:</label>
              <input
                type="date"
                id="startDate"
                value={startDate}
                max={endDate}
                onChange={(e) => handleDateChange(e, 'start')}
              />
            </div>
            <div className="date-pickerM">
              <label>Fecha de corte:</label>
              <input
                type="date"
                id="endDate"
                value={endDate}
                min={startDate}
                max={moment().format('YYYY-MM-DD')}
                onChange={(e) => handleDateChange(e, 'end')}
              />
            </div>
          </div>
          <div className="button-container">
            <button onClick={fetchData} className="search-buttonM">Actualizar Datos</button>
          </div>
        </div>

        {loading ? (
          <div className="loading-container">
            <Spin size="large" /> {/* Rueda de carga de Ant Design */}
          </div>
        ) : (
          sucursalData && (
            <div className="cards-containerUM">
              {/* Tarjetas principales */}
              <div className="rowUM">
                <div className="cardUM">
                  <div className="icon-circle-UM local-shipping-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px' }}>local_shipping</span>
                  </div>
                  <h3>Total Envíos</h3>
                  <p className="main-number">{totales.total}</p>
                </div>
                <div className="cardUM">
                  <div className="icon-circle-UM check-circle-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px' }}>trending_up</span>
                  </div>
                  <h3>Total Entregado</h3>
                  <p className="main-number">{totales.entregados}</p>
                  <div className="rate-container">
                    <span className="material-icons success-icon">check_circle</span>
                    <p className="rate">Tasa de Entrega</p>
                  </div>
                  <p className="success" style={{ color: "#4caf50", textAlign: "left", fontSize: "18px" }}>
                    {porcentajes.entrega}
                  </p>
                </div>
                <div className="cardUM">
                  <div className="icon-circle-UM report-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px' }}>repartition</span>
                  </div>
                  <h3>Devoluciones</h3>
                  <p className="main-number">{totales.devueltos}</p>
                  <div className="rate-container">
                    <span className="material-icons error-icon">cancel</span>
                    <p className="rate">Tasa de Devolución</p>
                  </div>
                  <p className="success" style={{ color: "#F44336", textAlign: "left", fontSize: "18px" }}>
                    {porcentajes.devolucion}
                  </p>
                </div>
              </div>

              <div className="rowUM">
                {/* Tarjeta: Estado envíos */}
                <div className="cardUM">
                  <div className="icon-circle-UM local-shipping-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px' }}>stacked_line_chart</span>
                  </div>
                  <h3>Estado Envios</h3>
                  <table className="card-table-UM">
                    <tbody>
                      {Object.entries(sucursalData?.estadisticas_pedidos || {})
                        .filter(([key]) => key !== 'total')
                        .map(([estado, cantidad], index) => (
                          <tr key={index}>
                            <td>{estado}</td>
                            <td className="number-cell-UM">{cantidad}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Tarjeta: Destinos más usados */}

                <div className="cardUM">
                  <div className="icon-circle-UM check-circle-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px' }}>scale</span>
                  </div>
                  <h3>Destinos Más Usados</h3>
                  <table className="card-table-UM">
                    <tbody>
                      {(showMore ? sucursalData?.destinos_comunes : sucursalData?.destinos_comunes?.slice(0, 5))?.map((destino, index) => (
                        <tr key={index}>
                          <td>{destino.ciudad}</td>
                          <td className="number-cell-UM">{destino.cantidad}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {sucursalData?.destinos_comunes?.length > 5 && (
                    <span
                      onClick={() => setShowMore(!showMore)}
                      style={{ color: "green", cursor: "pointer", textDecoration: "underline", marginLeft: "40%", marginTop: "2%" }}
                    >
                      {showMore ? "Ver menos" : "Ver más"}
                    </span>
                  )}
                </div>

                {/* Tarjeta: Devoluciones frecuentes */}
                <div className="cardUM">
                  <div className="icon-circle-UM report-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px' }}>warning</span>
                  </div>
                  <h3>Pedidos No Asignados</h3>
                  <table className="card-table-UM">
                    <tbody>
                      {sucursalData?.registros_No_Asignados?.registros?.map((registro, index) => (
                        <tr key={index}>
                          <td>Pedido #{registro.ID_pedido}</td>
                          <td className="number-cell-UM">{registro.fecha_pedido}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          )
        )}
        <Footer />
        <BotonWhatsapp />
      </div>
    </>
  );

};

export default Dashboard;